import { render, staticRenderFns } from "./UserManagementPage.vue?vue&type=template&id=6746328c&scoped=true"
import script from "./UserManagementPage.vue?vue&type=script&lang=js"
export * from "./UserManagementPage.vue?vue&type=script&lang=js"
import style0 from "./UserManagementPage.vue?vue&type=style&index=0&id=6746328c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6746328c",
  null
  
)

export default component.exports